import {useEffect} from 'react'
import {useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'

const RefinementsStyles = ({gridRef}) => {
    const isDesktop = useBreakpointValue({base: false, lg: true})

    useEffect(() => {
        let lastScrollTop = window.scrollY
        const refineMobile = document.getElementById('refine-sort-wrapper')
        const refineDesktop = document.getElementById('refinement-sort-section')

        const handleScroll = () => {
            const currentScrollTop = window.scrollY

            if (gridRef?.current) {
                const gridTop = gridRef.current.getBoundingClientRect().top

                if (gridTop < (isDesktop ? 230 : 100) && currentScrollTop < lastScrollTop) {
                    refineMobile?.classList.add('sticky-section-mobile')
                    refineDesktop?.classList.add('sticky-section-desktop')
                } else {
                    refineMobile?.classList.remove('sticky-section-mobile')
                    refineDesktop?.classList.remove('sticky-section-desktop')
                }
            }

            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop
        }
        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])
}

export default RefinementsStyles
